import axios from "axios";
import { getHeader } from "./user";
import { RequestPurchasePayload } from "../types/RequestPurchasePayload";

/**
 * Grants the recipient access to a licensed pre-sale report and sends them a
 * purchase link in a single authorised call (the backend adds them to the
 * access list and emails them).
 * Returns true on success, false on failure.
 */
export const requestPurchase = async (
    payload: RequestPurchasePayload
): Promise<boolean> => {
    try {
        const header = await getHeader();
        const url =
            process.env.REACT_APP_IDWAL_API_URL +
            `/Sellers/Inspections/${payload.inspectionId}/RequestPurchaseAccess`;

        await axios.post(url, payload, { headers: header });
        return true;
    } catch (error: any) {
        // Avoid logging the full axios error (it can include the auth header).
        console.error(
            "RequestPurchase failed:",
            error?.message ?? "Unknown error"
        );
        return false;
    }
};
